import { throttle } from 'lodash-es';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { NoSSR } from '@xing-com/crate-utils-no-ssr';

import { adSlotConfigPublift } from '../../ad-slot-config-publift';
import { useRegisterZone } from '../../hooks';

const OverflowContainer = styled.div`
  overflow-x: clip;
`;

const Wrapper = styled.div`
  width: 1030px;
  margin: 0 auto;
  position: relative;
`;

const AdContainer = styled.div<{ $isFixed: boolean }>`
  position: absolute;
  width: 160px;
  height: 600px;
  left: 100%;
  top: 290px;

  ${({ $isFixed }) =>
    $isFixed &&
    css`
      position: fixed;
      left: auto;
      top: 85px;
      margin-left: 1030px;
    `}
`;

export const DisplayAdProfileSidebarSlotPublift: React.FC = () => {
  const [isFixed, setIsFixed] = useState(false);

  const slotId = adSlotConfigPublift.Profile.sidebar.id;
  useRegisterZone(slotId);

  const setStickyPosition = (): void => {
    const topPosition = document.body.getBoundingClientRect().top;

    // Consider sticky navbar height
    setIsFixed(Math.abs(topPosition) >= 287);
  };

  useEffect(() => {
    const stickyCbThrottled = throttle(setStickyPosition, 100);
    window.addEventListener('scroll', stickyCbThrottled);

    return () => {
      window.removeEventListener('scroll', stickyCbThrottled);
    };
  }, []);

  return (
    <NoSSR>
      <OverflowContainer>
        <Wrapper>
          <AdContainer $isFixed={isFixed}>
            <div
              id={slotId}
              data-fuse={adSlotConfigPublift.Profile.sidebar.fuseTag}
            ></div>
          </AdContainer>
        </Wrapper>
      </OverflowContainer>
    </NoSSR>
  );
};
